import React, { useState, useEffect, useRef } from "react";
import {
    NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import {rectSortingStrategy} from '@dnd-kit/sortable';
// import { SortableMultiContainers } from "./sortableContainers/sortableMultiContainers";
import {MultipleContainers} from './sortableContainers/MultipleContainers';
import {SortableTree} from './sortableMenu/SortableTree'

import Icons from '../component/module.icons';
import axios from "axios";
import Cookies from 'js-cookie';
import gsap from "gsap";
import { apiCall } from "./narrativeUtils/fetch";

import Config from "../Config.json"
import Loader from "../static/svg/loader.svg";
import imagePlaceholder from '../static/img/image.png'
import Modal from './module.modal';
import FileDropZone from "./modules/dropzone";
// Icons
import OpenLink from "../static/svg/openLink-w.svg";
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import {ReactComponent as Close} from "../static/svg/close.svg"
import {ReactComponent as Image} from "../static/icons/image.svg"
import {ReactComponent as Video} from "../static/icons/video.svg"
import {ReactComponent as Svg} from "../static/icons/svg.svg"
import {ReactComponent as Delete} from "../static/icons/delete.svg"


function Module(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  const colorPicker = useRef();
  const uploadCounter = useRef(0);

  const [module, setModule] = useState(null);
  const [moduleObj, setModuleObj] = useState(null);
  const [modules, setModules] = useState([]);
  const [categories, setCategories] = useState();
  const [files, setFiles] = useState([]);
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [animOpen, setAnimOpen] = useState(false);
  const [dropDown, setDropDown] = useState();
  const [editField, setEditField] = useState(null);
  const [showAnimDropDown, setShowAnimDropDown] = useState(false);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [activeCategory, setActiveCategory] = useState();
  const [formError, setFormError] = useState();
  const [assignCatId, setAssignCatId] = useState();
  const [menuItems, setMenuItems] = useState();
  const [flatFileObjs, setFlatFileObjs] = useState();
  const [flatMenuItems, setFlatMenuItems] = useState();
  const [flatCatMenuItems, setCatFlatMenuItems] = useState();
  const [bulkUpload, setBulkUpload] = useState(false);
  const [bulkFiles, setBulkFiles] = useState(false);


  const fileTypes = ['image', 'video','vr']
  const rotations = ['horizontal', 'vertical','360']

  useEffect(() => {
    props.setTools("canvas")
    fetchJSON(null);

    props.setSmLogo(true)
    return () => {
      props.setSmLogo(false);
    }
    
    // login();
  }, []);

  useEffect(() => {

    if (moduleObj) {
      animModalIn(moduleObj.id)
      if (assignCatId) {
        handleModuleSave('filecategory', assignCatId)
      }
     
    }
  }, [moduleObj])

  useEffect(() => {
    module && setCategories(module.all_filecategories)
    module && setFiles(module.files_nocat)
    moduleObj && setModuleObj(module.files.find(obj => obj.id === moduleObj.id))
  }, [module])

  useEffect(() => {
    console.log('flatMenuItems', flatMenuItems)
  }, [flatMenuItems])
  

  useEffect(() => {
    categories && console.log('categories', categories)
    if (categories && (categories.length === 0) && files) {
      setShowCategoryForm(true)
    } else {
    
      setShowCategoryForm(false)
     
    }
    if (categories && categories.length > 0){
      let items = []
      let flatItems = {}
      let objs = []
      let categoriesOrdered = categories.sort((a, b) => a.ordering - b.ordering);
      console.log('categoriesOrdered', categoriesOrdered)
      categoriesOrdered.forEach((a, i) => {
        let cat = {
          id: a.id.toString(),
          name: a.name,
          file: null,
          index: i
        }
        items.push(cat)
        let itemArray = []
      
        a.categoryfiles && a.categoryfiles.length > 0 && a.categoryfiles.forEach((b, j) => {
          let item = {
            id: b.id.toString(),
            name: b.file,
            file: Config.mediaURL + b.thumbnail
          }
          itemArray.push(b.id.toString())
          items.push(item)
          objs.push(b)
        })
        let key = a.id.toString()

        // obj[key] = itemArray
        flatItems[key] = itemArray
      })

      if (files.length > 0) {
          let cat = {
            id: 'nocat',
            name: "",
            file: null,
            index: -1
          }
          items.push(cat)
    
      
        let itemArray = []
      
        files.length > 0 && files.filter(a => a.file !== "").forEach((b, j) => {
          let item = {
            id: b.id.toString(),
            name: b.file,
            file: Config.mediaURL + b.thumbnail
          }
          itemArray.push(b.id.toString())
          items.push(item)
          objs.push(b)
        })
        let key = 'nocat'

        // obj[key] = itemArray
        flatItems[key] = itemArray
     
      }
          
       
      
      setMenuItems(items)
      setFlatMenuItems(flatItems)
      setFlatFileObjs(objs)
      console.log('flat', flatItems)
      console.log('menuItems', items)

      let newList = [];
      categories.forEach((obj, i) => {
        let listObj = {
            id: obj.id.toString(),
            text: "<span>" + obj.name + "</span>",
            visible: null,
            locked: null,
            children: []
        }
        newList.push(listObj);
        setCatFlatMenuItems(newList);
      })
    
    }
  }, [categories, files])

  useEffect(() => {
    if (dropDown) {
      animDropDown(true)
    } else {
      animDropDown(false)
    }
  }, [dropDown])

  function handleBackBtn(){
    navigate('/narratives/' + module.narrative)
    setShowError(false);
  }

  function animDropDown(open){
    if (open) {
      let parent = document.getElementById('settingsRow_' + dropDown).offsetLeft;
      let dropDownElem = document.getElementById("inputField_" + dropDown + "_" + moduleObj.id ).offsetLeft;
      let offsetLeft = parent - dropDownElem;
      var tl = gsap.timeline();
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id + " .dropDownChoices", {height: "auto", duration: 0});
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id, {zIndex: 3, x: offsetLeft, height: "auto", duration: 0}, "<");
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id, {scale: 1, opacity: 1, duration: 0.1});
    } else {
      gsap.to(".dropDownChoices", {height: 0, duration: 0});
      gsap.to(".dropDownField", {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    }
  }

  function getModelFileType(string) {
    let fileType;
    var ext = string.split('.').pop().toLowerCase();
    switch (ext) {
      case "png":
        fileType = "image";
        break;
      case "jpg":
        fileType = "image";
        break;
      case "jpeg":
        fileType = "image";
        break;
      case "webp":
        fileType = "image";
        break;
      case "webm":
        fileType = "video";
        break;
      case "mp4":
        fileType = "video";
        break;
      case "svg":
        fileType = "image";
        break;
      default:
        break;
    }
    return fileType;
  }

  function getFileType(string) {
    let fileType;
    var ext = string.split('.').pop().toLowerCase();
    switch (ext) {
      case "png":
        fileType = "img";
        break;
      case "jpg":
        fileType = "img";
        break;
      case "jpeg":
        fileType = "img";
        break;
      case "webp":
        fileType = "img";
        break;
      case "mp4":
        fileType = "vid";
        break;
      case "svg":
        fileType = "svg";
        break;
      default:
        break;
    }
    return fileType;
  }
  

  function fileNameType(string, layerName) {
    let x0 = string.replace('gallery/', '');
    var ext = string.split('.').pop();
    let x2;
    if (layerName) {
      x2 = layerName;
    } else {
      x2 = x0.replace('.'+ ext, '');
    }
  
    // console.log('fileNameType', ext, x2, string);
    let icon;
    switch (ext) {
      case "png":
        icon = <Image className="icon" />
        break;
      case "jpg":
        icon = <Image className="icon" />
        break;
      case "jpeg":
        icon = <Image className="icon" />
        break;
      case "webp":
        icon = <Image className="icon" />
        break;
      case "svg":
        icon = <Svg className="icon" />
        break;
      case "mp4":
        icon = <Video className="icon" />
        break;
      default:
        break;
    }
    if (x2.length > 18) {
      x2 = x2.substring(0,18) + ' ...'
    }
    let result = [icon, x2];
    return result;
  }

  let moduleObjs = [];

  function animColorPicker(open, id){
    if (open !== id) {
      var tl = gsap.timeline();
      tl.to("#" + id, {height: "auto", duration: 0});
      tl.to("#" + id, {zIndex: 3, height: "auto", duration: 0}, "<");
      tl.to("#" + id, {scale: 1, opacity: 1, duration: 0.1});
      setAnimOpen(id);
    } else {
      gsap.to("#" + id, {height: 0, duration: 0});
      gsap.to("#" + id, {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
      setAnimOpen(null);
    }
  }

  function getModules(paths) {
    let moduleObjs = [];
    for(var i = 0; i < paths.length; i++) {            
      try {
        axios({
            method: "get",
            url: paths[i],
            headers: {
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            },
        }).then((response) => {
            const objJSON = response.data;
            moduleObjs.push(objJSON);

            if (paths.length === moduleObjs.length) {
              setModules(moduleObjs);
              console.log('modules', moduleObjs, paths.length)
            }
           
        });
      } catch (error) {
          console.error(error);
      }  
    }
   
    return paths.length === moduleObjs.length;
  }

  function fetchJSON(objId) {
 
    try {
        axios({
            method: "get",
            url: Config.baseURL + "/api/cms/gallery/" + id,
            headers: {
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            },
        }).then((response) => {
            const assetJSON = response.data;
            setModule(assetJSON);
            setShowLoader(false);
            if (objId) {
              setModuleObj(assetJSON.files.find(obj => obj.id === objId))
              // console.log('objId', objId)
            }
            console.log('activeCategory', activeCategory, assetJSON.categories)
            if (activeCategory) {
              setActiveCategory(assetJSON.categories.find(obj => obj.id === activeCategory.id))
            }
            // async function modulesLoaded(){
            //   await getModules(assetJSON.modules);
            //   setShowLoader(false);
            // };
            // modulesLoaded();
           
            
        });
    } catch (error) {
        console.error(error);
    }
}

    function handleAddFile(catId) {
      setShowLoader(true)
      const api_url = Config.baseURL + '/api/cms/gallery/' + id + "/";
      var dataJSON = {};
      dataJSON['status'] = "new"
      axios({
          method: 'POST',
          url: api_url,
          data: dataJSON,
          headers: {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('add file response', response.data['id'])
          fetchJSON(response.data['id']);
          if (catId){
            console.log('catId', catId)
            setAssignCatId(catId);
            
          }
      })
      .catch(error => {
          console.log('error', error.response);
      });
    }

    function handleAddCategory(name) {
      setShowLoader(true)
      const api_url = Config.baseURL + '/api/cms/gallery/' + id + "/";
      var dataJSON = {};
      dataJSON['new-category'] = name
      console.log('handleAddCategory', name)
      axios({
          method: 'POST',
          url: api_url,
          data: dataJSON,
          headers: {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          fetchJSON(response.data['id']);
          setShowCategoryForm(false);
          handleAddFile(response.data['id']);

      })
      .catch(error => {
          console.log('error', error.response);
      });
    }

    function handleGalleryMedia(e, fileName, objId){
   
      var fileList = e.target.files;
      var arrayLength = fileList.length;
      const api_url = Config.baseURL + '/api/cms/gallery/' + id.replace('gallery-', '') + "/";
    
      for (var i = 0; i < arrayLength; i++) {
    
        // File Checks
        let sizeMB = parseFloat(fileList[i].size / (1024 ** 2)).toFixed(2);
    
        if (sizeMB > props.user.org.validations.maxFileSize) {
    
            let newError = {
              "heading": "Error",
              "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
            };
            setFormError(newError);
    
        } else {
    
            setShowLoader(true)
            var formData = new FormData();
            formData.append(fileName, fileList[i], fileList[i].name) 
            formData.append('gallery', id.replace('gallery-', ''))
          
            console.log(fileName, fileList[i], fileList[i].name)
    
    
            axios({
                method: 'POST',
                url: api_url,
                data: formData,
                headers: {
                  'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
                },
            })
            .then(response => {
                console.log('handleGalleryMedia', response);
                fetchJSON();
            })
            .catch(error => {
                console.log('error', error.response);
            });
    
          }
        
    
      } 
    }
    

  

    function handleCategorySave(field, value, objId) {
      // setShowLoader(true)
      const api_url = Config.baseURL + '/api/cms/gallery-category/' + objId + "/";
      var dataJSON = {};
      dataJSON['gallery'] = id.replace('gallery-', '')
      dataJSON[field] = value;
      console.log('handleCategorySave', dataJSON)
      axios({
          method: 'POST',
          url: api_url,
          data: dataJSON,
          headers: {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('handleCategorySave', response);
          let d = document.getElementById('pageBtnContainer_'+ response.data['id']);
          d && d.classList.remove('open')
          setDropDown(null);
          setEditField(null);
          fetchJSON(null);
         
      })
      .catch(error => {
          console.log('error', error.response);
      });
    }

    function handleGalleryCategoryDelete(objId) {
      handleCategorySave('delete', true, objId)
    }

  function handleModuleSave(field, value) {
    // setShowLoader(true)
    props.onMouseLeave()
    const api_url = Config.baseURL + '/api/cms/gallery-file/' + moduleObj.id + "/";
    var dataJSON = {};
    dataJSON['gallery'] = id.replace('gallery-', '')
    // let category = categories.find(obj => obj.id === moduleObj.filecategory);
    // let index;
    // if (category) {
    //   index = category.categoryfiles.findIndex(obj => obj.id === moduleObj.id);
     
    // }
    // if (index > -1) {
    //   dataJSON['ordering'] = index
     
    // }

    if (field === 'end_pos' && value === "") {
      value = null
    }
    
    dataJSON[field] = value;

   

    console.log('handleModuleSave', dataJSON)
    axios({
        method: 'POST',
        url: api_url,
        data: dataJSON,
        headers: {
          'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
        },
    })
    .then(response => {
        console.log('handleModuleSave', response);
        setDropDown(null);
        fetchJSON(null);
        setAssignCatId(null)
    })
    .catch(error => {
        console.log('error', error.response);
    });
  }

  

  function handleModuleMedia(e, fileName){
    let fileList;
    fileList = e.target.files;

    var arrayLength = fileList.length;
    const api_url = Config.baseURL + '/api/cms/gallery-file/' + moduleObj.id + "/";

    for (var i = 0; i < arrayLength; i++) {

      // File Checks
      let sizeMB = parseFloat(fileList[i].size / (1024 ** 2)).toFixed(2);

      if (sizeMB > props.user.org.validations.maxFileSize) {

          let newError = {
            "heading": "Error",
            "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
          };
          setFormError(newError);

      } else {

          setShowLoader(true)
          var formData = new FormData();
          formData.append(fileName, fileList[i], fileList[i].name) 
          formData.append('gallery', id.replace('gallery-', ''))
          formData.append('active', moduleObj.active)
          if (!moduleObj.file) {
            formData.append('file_type', getModelFileType(fileList[i].name))
          }
          
          console.log('moduleOb', moduleObj, fileName, fileList[i], fileList[i].name)

          axios({
              method: 'POST',
              url: api_url,
              data: formData,
              headers: {
                'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
              },
          })
          .then(response => {
              console.log('handleModuleMedia', response);
              fetchJSON(null);
          })
          .catch(error => {
              console.log('error', error.response);
          });

        }
      

    } 
  }

  



  function handleThemeCss(field, value){
    let newCss;
    if (module.css) {
      newCss = module.css;
    } else {
      newCss = {};
    }
    if (value) {
      newCss[field] = value;
    } else {
      delete newCss[field]; 
    }
    handleModuleSave('css', newCss);

  }

  function animModalIn(objId){
    let target = "#moduleDetail_" + objId;
    gsap.to(target, {opacity: 1, duration: 0.2})
  }

  function animModalOut(objId, file){
    let target = "#moduleDetail_" + objId;
    if (file) {
      gsap.to(target, {opacity: 0, duration: 0.2, onComplete: setModuleObj(null)});
    } else {
      handleModuleSave('delete', true)
      setTimeout(() => {

        gsap.to(target, {opacity: 0, duration: 0.2, onComplete: setModuleObj(null)});
      }, 300);
    }
   
    


  }

  function round30(x) {
    let y = Math.ceil(x / 30) * 30;
    // console.log('y', y);
    return y;
}


function handleShowAnimDropDown() {
  if (showAnimDropDown) {
    setShowAnimDropDown(false);
  } else {
    setShowAnimDropDown(true);
  }
}

function handleDropDown(e, field) {
  if (field === dropDown) {
    setDropDown(null); 
  } else {
    setDropDown(field)
  }
}

function handleCategoryMedia(e, fileName, objId){
   
  var fileList = e.target.files;
  var arrayLength = fileList.length;
  const api_url = Config.baseURL + '/api/cms/gallery-category/' + objId + "/";

  for (var i = 0; i < arrayLength; i++) {

    // File Checks
    let sizeMB = parseFloat(fileList[i].size / (1024 ** 2)).toFixed(2);

    if (sizeMB > props.user.org.validations.maxFileSize) {

        let newError = {
          "heading": "Error",
          "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
        };
        setFormError(newError);
        setShowLoader(false);

    } else {

        setShowLoader(true)
        var formData = new FormData();
        formData.append(fileName, fileList[i], fileList[i].name) 
        formData.append('gallery', id.replace('gallery-', ''))
   


        axios({
            method: 'POST',
            url: api_url,
            data: formData,
            headers: {
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            },
        })
        .then(response => {
            console.log('handleCategoryMedia', response);
            fetchJSON();
        })
        .catch(error => {
            console.log('error', error.response);
        });

      }
    

  } 
}

function handleOnKeyUp(e, field, group, objId) {
    if (group === "file") {
      if (e.key === "Enter") {
        handleModuleSave(field, e.target.value);
        }
    }
    if (group === "category") {
      if (e.key === "Enter") {
        handleCategorySave(field, e.target.value, objId);
        }
    }
   

}

function handleActiveCategory(objId) {
  console.log('handleActiveCategory', objId)
  if (activeCategory && (activeCategory.id === Number(objId))) {
    setActiveCategory(null)
  } else {
    let cat = categories.find(a => a.id === Number(objId))
    setActiveCategory(cat)
  }
  
}

function onLayerSort(items) {
  console.log('onLayerSort', items)
  let files = []
  items.forEach((a, i) => {
    files.push(a.id)
  })
  onFilesSort(files)
}

function onLayerClick(id){
  console.log('onLayerClick', id)
  handleActiveCategory(id)
}

function onFileClick(fileId){
  console.log('onFileClick', fileId, flatFileObjs)
  let file = flatFileObjs.find(a => a.id === Number(fileId))
  if (file) {
    setModuleObj(file)
  }
  
}

function onFilesSort(files) {
  console.log('onFilesSort received', files, Array.isArray(files))

  const api_url = Config.baseURLcms + 'gallery-reorder/';
  let formData = {}

  let catIndex=0;
  let menuOrder = []

  if (Array.isArray(files)) {
    files.forEach((catId, i) => {
      if (catId !== 'nocat') {
        menuOrder.push({'id': Number(catId), 'ordering': i, 'subs': []})
      }
      
    })
    formData['categories'] = menuOrder
    formData['categoryfiles'] = []
  } else {
    for (const [key, value] of Object.entries(files)) {
      let id = "nocat"
      if (key !== "nocat") {
        id = Number(key)
      }
      let obj = {'id': id, 'ordering': catIndex, 'subs': []}
      obj['subs'] = [];
      value.forEach((a, i) => {
        obj['subs'].push({
          'id': Number(a),
          'ordering': i
        })
      })
      menuOrder.push(obj)
      catIndex+=1
    }
    formData['categories'] = []
    formData['categoryfiles'] = menuOrder
  }
  console.log('sending categories reorder', formData['categories'])
  function responseTask() {
    fetchJSON(null)
  }
  apiCall("POST", api_url, formData, responseTask, null, setFormError, setShowLoader)

}

function handleBulkUpload(){
  console.log('handleBulkUpload')
  setBulkUpload(true);
}


  async function handleBulkMedia(file){
    let fileList;
    fileList = [file]

    var arrayLength = fileList.length;
    const api_url = Config.baseURL + '/api/cms/gallery-bulk/' + module.id.replace('gallery-','') + "/";

    for (var i = 0; i < arrayLength; i++) {

      // File Checks
      let sizeMB = parseFloat(fileList[i].size / (1024 ** 2)).toFixed(2);

      if (sizeMB > props.user.org.validations.maxFileSize) {

          let newError = {
            "heading": "Error",
            "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
          };
          setFormError(newError);
          setShowLoader(false);

      } else {

          
          var formData = new FormData();
          formData.append('file', fileList[i], fileList[i].name) 
          formData.append('gallery', module.id.replace('gallery-',''))
          
          formData.append('active', true)
          formData.append('file_type', getModelFileType(fileList[i].name))
          
          console.log('file', fileList[i], fileList[i].name)
          try {
            const response = await axios({
              method: 'POST',
              url: api_url,
              data: formData,
              headers: {
                'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
              },
            });
            uploadCounter.current += 1;

            response.data && console.log('handleBulkMedi a', response.data);
            if (response.data && uploadCounter.current === bulkFiles.length) {
              console.log('All files uploaded successfully');
              setBulkUpload(false);
              setBulkFiles(false);
              uploadCounter.current = 0;
              fetchJSON(null);
              setShowLoader(false);
            }
          } catch (error) {
            console.log('error', error.response);
          }

        }
      

    }
    
  }


async function submitBulkUpload() {
  setShowLoader(true)
  for (const obj of bulkFiles) {
    console.log('submitFiles', obj, obj.name);
    await handleBulkMedia(obj);

 
  }
  
 
 
}

// useEffect(() => {

//   if (!bulkUpload && !bulkFiles) {
    
//      fetchJSON(null);
//   }
// }, [bulkUpload, bulkFiles])

function onItemContextMenu(e){
  console.log('onItemContextMenu', e)
}

    return (
        <section className="main" id="galleryPage">
        {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

        {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

        {(showError)&&(<div id="errorPopup"><div className="modal"><span><h3>Unsaved Changes</h3><p>Are you sure you want to go back?</p></span> <div className="fullRow errorRow"><span onClick={() => handleBackBtn('cancel')}>Cancel</span> <span onClick={() => handleBackBtn('force')}>Continue</span></div></div></div>)}



         {(bulkUpload)&&(<div id="bulkUploader">
          <div className="modal">
            <h3>Batch Upload <Icons.Close className="icon ui" onClick={() => {setBulkUpload(false); setBulkFiles(false)}}/></h3>
            
            <span className="dropZoneBox">
               <FileDropZone className="dropZone" setBulkFiles={setBulkFiles} />
               {bulkFiles && bulkFiles.length > 0 && <span className="dropZoneUploadBtn" onClick={() => submitBulkUpload()}>Upload</span>}
            </span>
          
          </div>
          </div>)}


        {(showCategoryForm)&&(<div className="modalContainer"><div className="modal"><span><h3>New Category</h3>

        <div className="settingsRow">
          <input type="text" autoComplete="off" id="newCategoryName" autoFocus placeholder="Add Category Name" />
        </div>

        </span> <div className="fullRow errorRow"><span onClick={() => {
          setShowCategoryForm(false)
        }}>Cancel</span> <span onClick={() => handleAddCategory(document.getElementById('newCategoryName').value)}>Continue</span></div></div></div>)}
        
        
        {module && <div className="col appGrid">

        <div id="narrativeTools">
          
        

        <div className="iconField ui" onClick={() => setShowCategoryForm(true)}><Icons.StateBtnAdd className="icon ui" title="Add Category" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Category")} onMouseLeave={() => props.onMouseLeave() } /></div>

          <div className="iconField ui" onClick={() =>handleAddFile()}><Icons.PhotoAdd className="icon ui" title="Add File" onMouseEnter={(e) =>props.onMouseEnter(e, "Add File")} onMouseLeave={() => props.onMouseLeave() } /></div>

          <div className="iconField ui" onClick={() =>handleBulkUpload()}><Icons.BulkUpload className="icon ui" title="Batch Upload" onMouseEnter={(e) =>props.onMouseEnter(e, "Batch Upload")} onMouseLeave={() => props.onMouseLeave() } /></div>

          <h1>{module.title}</h1>

          <a href={ Config.previewURL + "/narrative/" + module.narrative + '?u=' + props.user.link_token + "&module=" + module.id} className="previewBtn previewBtnGallery" target="_blank" rel="noreferrer" title="preview">
          <img src={OpenLink} className="icon" alt="" /></a>

          </div>
            <nav className="leftNav">
            
  
              <div className="leftArrow iconField" onClick={() => handleBackBtn()}>
                <ArrowBack className="icon" /> 
  
                <div className="pages">Spaces Overview</div>
              </div>

              <div className="pages fieldRow modulePages">
                  <div  className="sectionRows">
                  

                    <div className="layerToggle">
                    <span className={`layerToggleBtn on`}>Categories</span>

                   
                  </div>
                  
                  {flatCatMenuItems && <div 
                    className={"sortableBox"}
                  ><SortableTree  
                    defaultItems={flatCatMenuItems}
                    indicator
                    category={'layers'}
                    activationConstraint={{
                      delay: 200,
                      tolerance: 15,
                    }} 
                    activePageId={props.activeSettingId}
                    // Functions
                    // setEditPageForm={props.setEditPageForm} //this is for delete only
                    onMenuSort={onLayerSort}
                    onItemClick={onLayerClick}
                    isDragActive={true}
                    onItemContextMenu={onItemContextMenu}
                  /></div>}



                  
                  </div>

              </div>
            </nav>
            <div className="core">

            <div className="twoCol">
            {menuItems && flatMenuItems && flatFileObjs &&  <MultipleContainers 
              strategy={rectSortingStrategy} 
              vertical 
              columns={3} 
              defaultIds={flatMenuItems} 
              defaultItems={menuItems} 
              onContainerClick={onLayerClick}
              onItemClick={onFileClick}
              onMenuSort={onFilesSort}
              onItemContextMenu={onItemContextMenu}
              activationConstraint={{
                  delay: 200,
                  tolerance: 15,
                }} 
              /> }

              
              </div>
            </div>     
           
          

         </div>}
        

            {activeCategory && <div className="rightNav settingsOn" id="manifestColumn">
            <div className={"mediaSettings showSettings on"}>

            <div className="settingsGroup">
            <div className="groupLabel"><p>Gallery Settings</p></div>
              <div className="settingsRow">
              <div className="moduleHeading">
              {module && <div className="fieldRow">
                  <div className="errors"></div>

                    <div className="canvasLabel">Default Landing Image</div>
                    {module.default_image ? <img src={Config.mediaURL + module.default_image} alt="" className="thumbnail" onClick={() => document.getElementById("default_image_" + module.id).click()} /> : <span className="btn1 autoWidth" onClick={() => document.getElementById("default_image_" + module.id).click()}>Add Image</span>}
                    <input type="file" style={{display: "none"}} autoComplete="off" id={"default_image_" + module.id} accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleGalleryMedia(e, 'default_image', module.id)}  />


                
              </div>}
              </div>
              </div>
              

            </div>
              <div className="settingsGroup">
                <div className="groupLabel"><p>Category Settings</p></div>
                  <div className="settingsRow">
                    
                      <div className="fieldRow">
                          <div className="errors"></div>
                            <div className="canvasLabel">Heading</div>
                            <input type="text" autoComplete="off" id="narrativeHeading" key={activeCategory.id} defaultValue={activeCategory.name} onKeyUp={(e) => handleOnKeyUp(e, 'name', 'category', activeCategory.id)} />
                      </div>
              

              
                  </div>

                  <div className="settingsRow">
                    <div className="moduleHeading" id={"category_thumbnail" + activeCategory.id}>
                      <div className="fieldRow">
                          <div className="errors"></div>
                         
                            <div className="canvasLabel">Thumbnail</div>
                            {activeCategory.thumbnail ? <img src={Config.mediaURL + activeCategory.thumbnail} alt="" className="thumbnail" onClick={() => document.getElementById("category_thumbnail_" + activeCategory.id).click()} /> : <span className="btn1 autoWidth" onClick={() => document.getElementById("category_thumbnail_" + activeCategory.id).click()}>Add Thumbnail</span>}
                            <input type="file" style={{display: "none"}} autoComplete="off" id={"category_thumbnail_" + activeCategory.id} accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleCategoryMedia(e, 'thumbnail', activeCategory.id)}  />

                
                        
                      </div>
                    </div>
                  </div>
        
              </div>

              {activeCategory.id && <div className="settingsRow deleteRow deleteBtn">             
                <div className="iconField ui" onMouseEnter={(e) =>props.onMouseEnter(e, "Double click to delete")} onMouseLeave={() => props.onMouseLeave() } onDoubleClick={() => handleGalleryCategoryDelete(activeCategory.id)}><Delete className="icon"/> <div className="canvasLabel">Delete Category</div>
                </div>
              </div>}     
            </div>
            </div>}



  {moduleObj && 
    <div className="moduleDetail" id={"moduleDetail_" + moduleObj.id}>
      
      <div className="moduleContainer">
        <div className="closeModal ui" onClick={() => {animModalOut(moduleObj.id, moduleObj.file) }}><Close className="icon" /></div>

        <span className="file">
          
          {(moduleObj.file && getFileType(moduleObj.file) === 'img') && <span className="fileImage">
          <img src={Config.mediaURL + moduleObj.file} alt="" onClick={() => document.getElementById("inputField_file_" + moduleObj.id).click()} />
          </span>}

          {(moduleObj.file && getFileType(moduleObj.file) === 'vid') && <span className="fileVideo">
            <video key={moduleObj.file} width="320" height="240" controls>
              <source src={Config.mediaURL + moduleObj.file} type="video/mp4" />
            </video>
          </span>}

          {!moduleObj.file && <div className="ui filePlaceholder autoWidth" 
          onClick={() => document.getElementById("inputField_file_" + moduleObj.id).click()} >Add File</div>}
        
          <input type="file" style={{display: "none"}} autoComplete="off" id={"inputField_file_" + moduleObj.id} accept={"image/png, image/jpeg, image/webp, video/mp4"} onChange={(e) => handleModuleMedia(e, 'file')}  />
        </span>
        

        <div className="moduleSettings">
          <div className="groupLabel"><p>File Settings</p></div>


          
          <div className="row settingsGridFull" id="settingsRow_category">
          <div className="canvasLabel">Category</div>
            
          <div className="dropDownRow">
            <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'category')}> 
              {moduleObj.filecategory || (!moduleObj.file && activeCategory) ?  
                moduleObj.filecategory ? (categories.find(obj => obj.id === moduleObj.filecategory).name) : activeCategory.name : 
                <span className="canvasLabel">Select Category</span>
              }
                
                <Icons.ChevronDown className="icon" /></div>
            <span className="inputField dropDownField" id={"inputField_category_" + moduleObj.id}>
              <span className="dropDown">
                <span className="dropDownChoices">
                  {categories
                    .sort((a, b) => a.ordering - b.ordering)
                    .map((obj, i) => (
                    <span 
                      key={'fileCategory_'+i} 
                      className={"dropDownChoice ui"}
                      onClick={() => handleModuleSave('filecategory', obj.id)}
                      >{obj.name}</span>
                  ))}
                </span>
              </span>
            </span> 
          </div>  
          </div>  

          <div className="row settingsGridFull" id="settingsRow_fileType">
            <div className="canvasLabel">File Type</div>
            <div className="dropDownRow">
            <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'fileType')}>{moduleObj.fileType ?  fileTypes.find(obj => obj === moduleObj.fileType) : <span className="canvasLabel">Select File Type</span>} <Icons.ChevronDown className="icon" /></div>
            <span className="inputField dropDownField" id={"inputField_fileType_" + moduleObj.id}>
              <span className="dropDown">
                <span className="dropDownChoices">
                  {fileTypes
                    .sort((a, b) => a.ordering - b.ordering)
                    .map((obj, i) => (
                    <span 
                      key={'fileType_'+i} 
                      className={"dropDownChoice ui"}
                      onClick={() => handleModuleSave('fileType', obj)}
                      >{obj}</span>
                  ))}
                </span>
              </span>
            </span> 
          </div>
          </div>
        
          {(moduleObj.fileType === "vr") && <div className="row settingsGridFull" id="settingsRow_rotation">
            <div className="canvasLabel">Movement</div>
            <div className="dropDownRow">
            <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'rotation')}>{moduleObj.rotation ?  rotations.find(obj => obj === moduleObj.rotation) : <span className="canvasLabel">Select Rotation</span>}</div>
            <span className="inputField dropDownField" id={"inputField_rotation_" + moduleObj.id}>
              <span className="dropDown">
                <span className="dropDownChoices">
                  {rotations
                    .sort((a, b) => a.ordering - b.ordering)
                    .map((obj, i) => (
                    <span 
                      key={'rotation_'+i} 
                      className={"dropDownChoice ui"}
                      onClick={() => handleModuleSave('rotation', obj)}
                      >{obj}</span>
                  ))}
                </span>
              </span>
            </span> 
            </div>
          </div>}

          {(moduleObj.fileType === "vr") && <div className="settingsRow" id="start_pos">
            <div className="canvasLabel">Start Position</div>
            <input type="number" autoComplete="off" id="caption" defaultValue={moduleObj.start_pos} onChange={(e) => handleModuleSave('start_pos', e.target.value)} onKeyUp={(e) => handleOnKeyUp(e, 'start_pos', 'file', null)} />
          </div>}

          {(moduleObj.fileType === "vr") && <div className="settingsRow" id="end_pos">
            <div className="canvasLabel">End Position</div>
            <input type="number" autoComplete="off" id="caption" defaultValue={moduleObj.end_pos} onChange={(e) => handleModuleSave('end_pos', e.target.value)} onKeyUp={(e) => handleOnKeyUp(e, 'end_pos', 'file', null)} />
          </div>}

          {(moduleObj.fileType === "vr") &&  <div className="settingsRow">
          <div className="moduleHeading" id={"inputField_vr_ref" + moduleObj.id}>
          <div className="fieldRow">
              <div className="errors"></div>
      
                <div className="canvasLabel">Viewport Base Image</div>
                {moduleObj.vr_ref ? <img src={Config.mediaURL + moduleObj.vr_ref} alt="" className="thumbnail" onClick={() => document.getElementById("inputField_vr_ref_" + moduleObj.id).click()} /> : <span className="btn1 autoWidth" onClick={() => document.getElementById("inputField_vr_ref_" + moduleObj.id).click()}>Add Viewport Base Image</span>}
                <input type="file" style={{display: "none"}} autoComplete="off" id={"inputField_vr_ref_" + moduleObj.id} accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleModuleMedia(e, 'vr_ref')}  />

    
            
          </div></div></div>}

          <div className="settingsRow">
            <div className="moduleHeading" id={"inputField_caption" + moduleObj.id}>
            <div className="fieldRow">
                <div className="errors"></div>
        
                  <div className="canvasLabel">Caption</div>
                  <input type="text" autoComplete="off" id="caption" defaultValue={moduleObj.caption} onChange={(e) => handleModuleSave('caption', e.target.value)} onKeyUp={(e) => handleOnKeyUp(e, 'caption', 'file', null)} />
              
            </div>
            
            </div>
          </div>
          
          <div className="settingsRow">
          <div className="moduleHeading" id={"inputField_thumbnail" + moduleObj.id}>
          <div className="fieldRow">
              <div className="errors"></div>
      
                <div className="canvasLabel">Thumbnail</div>
                {moduleObj.thumbnail ? <img src={Config.mediaURL + moduleObj.thumbnail} alt="" className="thumbnail" onClick={() => document.getElementById("inputField_thumbnail_" + moduleObj.id).click()} /> : <span className="btn1 autoWidth" onClick={() => document.getElementById("inputField_thumbnail_" + moduleObj.id).click()}>Add Thumbnail</span>}
                <input type="file" style={{display: "none"}} autoComplete="off" id={"inputField_thumbnail_" + moduleObj.id} accept={"image/png, image/jpeg, image/webp"} onChange={(e) => handleModuleMedia(e, 'thumbnail')}  />

    
            
          </div>

          <div className="fieldRow">
          {(moduleObj.file && getFileType(moduleObj.file) === 'vid') && <div className="ui btn1 autoWidth" onClick={() => document.getElementById("inputField_file_" + moduleObj.id).click()} >Replace Video</div>}
          </div>

          
          
        
          </div>

          <div className="settingsRow deleteRow">             
            <div className="iconField ui"  onMouseEnter={(e) =>props.onMouseEnter(e, "Double click to delete")} onMouseLeave={() => props.onMouseLeave() } onDoubleClick={() => handleModuleSave('delete', true)}><Delete className="icon"/> <div className="canvasLabel">Delete File</div>
            </div>
          </div>        

        </div>
          


        </div>

        
      </div>
    </div>
    
  }

      </section>
    );
}

export default Module;
